'use client';

// import "swiper/swiper-bundle.css";
import React from "react";
import Headline from "@/components/ui/Headline/Headline";
import DeviceShowcaseCard from "@/components/client/DeviceShowcaseCard/DeviceShowcaseCard";
import { LanguageType, LanguageDirection, BeautyDeviceSectionContent } from "@/lib/types";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from "@gsap/react";
import { useIsLg } from '@/contexts/BreakpointContext';
gsap.registerPlugin(useGSAP, ScrollTrigger);

interface DevicesSectionProps {
  language?: LanguageType
  headlineText: string
  subheadingText: string
  paragraphText: string
  beautyDevicesSectionPageData: BeautyDeviceSectionContent
}

const LANGUAGE_TO_DIRECTION: Record<LanguageType, LanguageDirection> = {
  english: "ltr",
  arabic: "rtl"
};

interface ImageCard {
  imageUrl: string;
  altText: string;
  title: string;
  description: string;
  logoUrl: string;
}

// const imageCards: ImageCard[] = [
//   {
//     id: 1,
//     // imageUrl: "https://picsum.photos/1300/1100?random=1",
//     imageUrl: "./hero-image.avif",
//     title: "Card 1",
//     description: "Description for card1",
//     // description: "A device that allows to work more precisely and achieve excellent results in a non-invasive way. The unique combination of four powerful functions: radio frequency, LED therapy, vacuum and transdermal oscillations, creates a dynamic solution to deliver a diverse range of transformative results for the face and body",
//   },
//   {
//     id: 2,
//     // imageUrl: "https://picsum.photos/1300/1100?random=2",
//     imageUrl: "./hero-image.avif",
//     title: "Card 2",
//     description: "Description for card2",
//   },
//   {
//     id: 3,
//     // imageUrl: "https://picsum.photos/1300/1100?random=3",
//     imageUrl: "./hero-image.avif",
//     title: "Card 3",
//     description: "Description for card3",
//   },
//   {
//     id: 4,
//     // imageUrl: "https://picsum.photos/1300/1100?random=4",
//     imageUrl: "./hero-image.avif",
//     title: "Card 4",
//     description: "Description for card4",
//   },

// ];


// TODO: the image gets waaaay to big if there are 1 or 2 devices only. place some max constraints

const DevicesSection: React.FC<DevicesSectionProps> = ({
  language = "english",
  beautyDevicesSectionPageData,
  headlineText,
  subheadingText,
  paragraphText
}) => {
  const isLg = useIsLg();
  // const containerRef = useRef<HTMLDivElement>(null);

  const imageCards: ImageCard[] = [...beautyDevicesSectionPageData.beautyDevices].sort((a, b) => a.deviceOrder - b.deviceOrder).map((device) => ({
    imageUrl: device.deviceImage.url,
    altText: device.deviceImageAltText,
    title: device.deviceName,
    description: device.deviceDescription,
    logoUrl: device.deviceLogo.url
  }));


  // TODO: triggers are a bit off here - dont know why atm

  useGSAP(() => {
    // const container = containerRef.current;
    // if (container) {
    if (isLg) {
    const cards: HTMLElement[] = Array.from(document.querySelectorAll('.device-image-card'));

    cards.forEach(card => {
      gsap.fromTo(card, {
        yPercent: -10,
      }, {
        yPercent: 10,
        ease: "none",
        force3D: true,
        scrollTrigger: {
          trigger: card,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          // markers: true,
          id: "devices-section-scroll-trigger"
        },
        onEnter: () => {
          card.style.willChange = "transform";
        },
        onLeave: () => {
          card.style.willChange = "auto";
        },
        onEnterBack: () => {
          card.style.willChange = "transform";
        },
        onLeaveBack: () => {
          card.style.willChange = "auto";
        }
      });
    });
  }
  // }, [] );
  }, { dependencies: [isLg], revertOnUpdate: true });
  // }, { dependencies: [], revertOnUpdate: true});

  return (
    // section has custom padding!
    <section className="
      w-full flex flex-col items-center justify-center
      gap-[2rem] lg:gap-[6rem]
      padding-main-x-mobile
      padding-main-x-desktop
      pt-[2rem]
      padding-main-t-desktop
      overflow-hidden
    ">
      <div
        style={{ direction: LANGUAGE_TO_DIRECTION[language] }}
        className="
          w-full container-large"
      >

        <div className="flex flex-row items-center justify-start w-full">
          <Headline
            type="short"
            alignment={language === "english" ? 'left' : 'right'}
            heading={headlineText}
            paragraph={paragraphText}
            subheading={subheadingText}
            language={language}
          />

        </div>
      </div>

      <div
        style={{ direction: LANGUAGE_TO_DIRECTION[language] }}
        className="w-full container-large overflow-visible">
        <div
          // ref={containerRef}
          className="
            gap-y-[2.5rem] gap-x-[1rem]
            grid
            [grid-template-columns:repeat(auto-fit,minmax(min(100%,20rem),1fr))]
          ">
          {imageCards.map((card) => (
            <DeviceShowcaseCard
              key={card.title}
              imageUrl={card.imageUrl}
              imageAlt={card.title}
              title={card.title}
              description={card.description}
              language={language}
              badgeSize={isLg ? 'desktop' : 'mobile'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}


export default DevicesSection;
